import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'react'

let ErrorBoundary = null

/* 
NOTE this makes the assumption of the following domain - release stage mappings:
  1. powcloud.com (production)
  2. powcloud-dash-production.herokuapp.com (production)
  3. powcloud-dash-staging.herokuapp.com (staging)
  4. powcloud-dash-dev.herokuapp.com (development)
  5. powcloud.test (no stage, this is local development. IGNORE)
*/

if (!window.location.host.includes('powcloud.test')) {
  try {
    let releaseStage = 'development'
    if (window.location.host.includes('powcloud.com') || window.location.host.includes('powcloud-dash-production.herokuapp.com')) releaseStage = 'production'
    else if (window.location.host.includes('powcloud-dash-staging.herokuapp.com')) releaseStage = 'staging'

    console.log('Bugsnag release stage', releaseStage)

    Bugsnag.start({
      apiKey: process.env.BUGSNAG_FE,
      plugins: [new BugsnagPluginReact()],
      releaseStage: releaseStage, //process.env.BUGSNAG_RELEASE_STAGE
    })

    ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)
  } catch (e) {
    // this is the case where bugsnag keys aren't provided (i.e. local dev environments)
    // in this case, export error boundary that is null
    console.error('Bugsnag initialization error', e)
  }
}

export { Bugsnag, ErrorBoundary }
